import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { FONTS, fontSize } from "../../../styles/fonts";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import cn from "classnames";

export const SearchResultsSummary: ReactTFC<{
  summary: Array<{ text: string; id: string; count: number }>;
  totalCount: number;
  text: string;
}> = props => {
  return (
    <p
      className={cn("_summary u-ta-center", { hidden: props.totalCount === 0 })}
      css={[
        FONTS.SwarovskiFutura300,
        fontSize.x2,
        css`
          > ._highlight {
            font-weight: 500;
            color: ${CSS_COLORS.Green};
          }

          &.hidden {
            display: none;
          }
        `,
      ]}
    >
      {props.text}
      {" — "}
      {props.summary.map((e, idx, ctx) => {
        return (
          <React.Fragment key={e.id}>
            {idx === ctx.length - 1 ? <span>{" and "}</span> : idx > 0 ? <span>{", "}</span> : null}
            <Element size={e.count} id={e.id} text={e.text} />
          </React.Fragment>
        );
      })}
    </p>
  );
};

const Element: ReactTFC<{ size: number; id: string; text: string }> = props => {
  if (props.size > 0) {
    return (
      <a
        className={"_highlight"}
        href={`#${props.id}`}
        css={css`
          text-decoration: none;
        `}
      >
        {props.text}
      </a>
    );
  } else {
    return <span>{props.text}</span>;
  }
};
